import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import { MessageContext } from '@/helpers/MessageProvider';

const useAuthorizeCommand = () => {
  const user = useSelector((state) => state.user);
  const { publishCommand } = useContext(MessageContext);

  const request = () => (robot) => {
    const tid = uuidv4();
    const bid = uuidv4();

    const execute = () => publishCommand(robot, 'authorize/request', [tid, bid, Date.now(), user.id, user.name]);

    // TODO: 명령 수행 결과 처리를 위한 추가 정보 전달
    return {
      execute,
    };
  };

  return {
    request,
  };
};

export default useAuthorizeCommand;
